module.exports = __webpack_public_path__ + "img/December.bbef4eb5.png";